import React, { useEffect, useRef, useState } from 'react';

const HtmlContent = ({
  classNameContainer = '',
  content = '',
  elementId = '',
  elementType = 'div',
  shouldRefresh = false,
}) => {
  const [contentLoaded, setContentLoaded] = useState();
  const ref = useRef();

  useEffect(() => {
    if (ref.current && content
      && (shouldRefresh || (!shouldRefresh && !contentLoaded))) {
      const elementExists = document.getElementById(elementId);

      if (elementExists) {
        if (shouldRefresh) {
          ref.current.removeChild(elementExists);
        } else {
          return;
        }
      }

      const htmlContent = content;
      const htmlContainer = document.createElement(elementType);
      htmlContainer.classList.add(classNameContainer);
      htmlContainer.innerHTML = htmlContent;
      htmlContainer.setAttribute('id', elementId);
      ref.current.appendChild(htmlContainer);
      setContentLoaded(true);
    }
  }, [
    classNameContainer,
    content,
    contentLoaded,
    shouldRefresh,
    elementId,
    elementType,
    ref,
  ]);

  return (
    <div ref={ref} />
  );
};

export { HtmlContent };
